"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImagePicker = void 0;
const react_1 = __importStar(require("react"));
const lu_1 = require("react-icons/lu");
const utils_1 = require("../../lib/utils");
const ACCEPTED_FORMATS = "image/jpeg, .jpeg, image/png, .png, image/gif, .gif, image/bmp, .bmp, image/webp, .webp, image/svg+xml, .svg";
const defaultStyles = "tw-flex tw-justify-center tw-items-center tw-w-full tw-box-border tw-h-32 tw-p-7 tw-rounded-md tw-border tw-border-dashed tw-border-neutral-100 tw-bg-transparent tw-transition-colors";
const fontStyles = "tw-text-xs tw-font-semibold tw-font-sans";
const textStyles = "tw-flex tw-max-w-60 tw-text-center tw-text-primaryDim-300";
const focusStyles = "focus-visible:tw-ring-ring focus-visible:tw-outline-none focus-visible:tw-ring-1 focus-visible:tw-border-solid focus-visible:tw-border-primary-300";
const lockedStyles = "disabled:tw-bg-primary-25 disabled:tw-cursor-default disabled:tw-border-solid";
const readOnlyStyles = "disabled:tw-bg-primaryDim-25 disabled:tw-cursor-default disabled:tw-border-solid";
const imageSelectedStyles = "!tw-border-solid";
const draggingStyles = "tw-rounded-md !tw-border-solid tw-border-secondary-300 !tw-bg-secondary-50 tw-text-neutral-500";
const ImagePicker = (0, react_1.forwardRef)(({ url, defaultUrl, locked, readOnly, onSelectFile = () => { }, className = "", placeholder = "Upload here", placeholderSubtext = "", }, ref) => {
    const inputRef = react_1.default.useRef(null);
    const [dragging, setDragging] = (0, react_1.useState)(false);
    const [internalValue, setInternalValue] = (0, react_1.useState)(defaultUrl || "");
    const handleFileSelect = (file) => {
        onSelectFile(file);
        setInternalValue(URL.createObjectURL(file));
    };
    const handleFileDrop = (event) => {
        event.preventDefault();
        setDragging(false);
        if (!event.dataTransfer.files) {
            return;
        }
        handleFileSelect(event.dataTransfer.files[0]);
    };
    const handleDragOver = (event) => {
        event.preventDefault();
        setDragging(true);
    };
    const handleInputChange = (event) => {
        const files = event.target.files;
        if (!files?.length) {
            return;
        }
        handleFileSelect(files[0]);
    };
    const handleButtonClick = () => {
        inputRef.current?.click();
    };
    const renderImage = () => (react_1.default.createElement("div", { className: "tw-flex tw-h-full tw-w-full tw-justify-center" },
        react_1.default.createElement("img", { src: url || internalValue, alt: "logo-image" })));
    const renderPlaceholder = () => {
        if (dragging) {
            return (react_1.default.createElement("div", { className: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2" },
                react_1.default.createElement(lu_1.LuFilePlus2, { className: "tw-h-6 tw-w-6 tw-text-neutral-500" }),
                react_1.default.createElement("p", { className: (0, utils_1.cn)(textStyles, "!tw-text-neutral-500") }, "Drop file here")));
        }
        return (react_1.default.createElement("p", { className: (0, utils_1.cn)(textStyles) },
            placeholder,
            react_1.default.createElement("br", null),
            placeholderSubtext));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("button", { type: "button", className: (0, utils_1.cn)(defaultStyles, focusStyles, fontStyles, {
                [lockedStyles]: locked,
                [readOnlyStyles]: readOnly,
                [imageSelectedStyles]: url || internalValue,
                [draggingStyles]: dragging,
            }, className), onClick: handleButtonClick, onDrop: handleFileDrop, onDragOver: handleDragOver, onDragExit: () => setDragging(false), disabled: locked || readOnly, ref: ref }, url || internalValue ? renderImage() : renderPlaceholder()),
        react_1.default.createElement("input", { ref: inputRef, type: "file", onChange: handleInputChange, className: (0, utils_1.cn)("tw-hidden", className), accept: ACCEPTED_FORMATS })));
});
exports.ImagePicker = ImagePicker;
ImagePicker.displayName = "ImagePicker";
